/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from 'ng2-translate/src/translate.pipe';
import * as import2 from 'ng2-translate/src/translate.service';
import * as import3 from './exit-page.component';
import * as import4 from '../../config-support/param-config.service';
const styles_ExitPageComponent:any[] = ([] as any[]);
export const RenderType_ExitPageComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_ExitPageComponent,
  data: {}
}
);
export function View_ExitPageComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'exit-message'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n    ',
      '\n'
    ]
    )),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,2).transform('woa.message.exit.goodbye'));
    ck(v,1,0,currVal_0);
  });
}
function View_ExitPageComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-exit-page',([] as any[]),(null as any),(null as any),(null as any),View_ExitPageComponent_0,RenderType_ExitPageComponent)),
    import0.ɵdid(114688,(null as any),0,import3.ExitPageComponent,[import4.ParamConfigService],(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const ExitPageComponentNgFactory:import0.ComponentFactory<import3.ExitPageComponent> = import0.ɵccf('woa-exit-page',import3.ExitPageComponent,View_ExitPageComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvc3RhcnQvZXhpdC1wYWdlL2V4aXQtcGFnZS5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS9ydW5uZXIvd29yay93ZWItb3JkZXJpbmctYXBwL3dlYi1vcmRlcmluZy1hcHAvc3JjL2FwcC9zdGFydC9leGl0LXBhZ2UvZXhpdC1wYWdlLmNvbXBvbmVudC50cyIsIm5nOi8vL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvc3RhcnQvZXhpdC1wYWdlL2V4aXQtcGFnZS5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvc3RhcnQvZXhpdC1wYWdlL2V4aXQtcGFnZS5jb21wb25lbnQudHMuRXhpdFBhZ2VDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8ZGl2IGNsYXNzPVwiZXhpdC1tZXNzYWdlXCI+XG4gICAge3snd29hLm1lc3NhZ2UuZXhpdC5nb29kYnllJyB8IHRyYW5zbGF0ZX19XG48L2Rpdj5cbiIsIjx3b2EtZXhpdC1wYWdlPjwvd29hLWV4aXQtcGFnZT4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O01DQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUEwQjtNQUFBO01BQUE7SUFBQTtJQUFBO2dCQUFBOzs7SUFBQTtJQUFBO0lBRXBCOzs7SUFGb0I7SUFBQTs7Ozs7SUNBMUI7Z0JBQUE7OztJQUFBOzs7In0=



// WEBPACK FOOTER //
// ./src/app/start/exit-page/exit-page.component.ngfactory.ts